import * as actions from "./actions";
import { Map } from "immutable";
import { Record } from "../transit";
import { ValidationError } from "../lib/validation";
import Alert from "react-s-alert";

import { hashFromObj } from "../lib/utils/hash";

import { normalize, Schema, arrayOf } from "normalizr";

const article = new Schema("articles", { idAttribute: "uid" });

const State = Record(
  {
    map: Map(),
    results: Map(),
    meta: new (Record(
      {
        currentPage: 1,
        limit: 15,
        offset: 0,
        sortDir: "desc",
        sortField: "createdAt",
        showUnvisible: true
      },
      "meta"
    ))(),
    deleteStatus: 0,
    form: new (Record(
      {
        loading: false,
        fileLoading: false,
        filePreview: null,
        error: null
      },
      "form"
    ))()
  },
  "article"
);

const articlesReducer = (state = new State(), action) => {
  switch (action.type) {
    case actions.CREATE_ARTICLE: {
      return state.setIn(["form", "loading"], true);
    }

    case actions.CREATE_ARTICLE_SUCCESS: {
      Alert.success("Dodano artykuł", {
        position: "bottom-right",
        timeout: 3000
      });
      return state.setIn(["form", "loading"], false);
    }

    case actions.CREATE_ARTICLE_ERROR: {
      const { errors, data } = action.payload;
      return state
        .setIn(["form", "error"], errors)
        .setIn(["form", "loading"], false);
    }

    case actions.CREATE_ARTICLE_FINALLY: {
      return state.setIn(["form", "loading"], false);
    }

    case actions.CREATE_ARTICLE_IMAGE: {
      return state.setIn(["form", "fileLoading"], true);
    }

    case actions.CREATE_ARTICLE_IMAGE_SUCCESS: {
      const { data } = action.payload;
      return state
        .setIn(["form", "fileLoading"], false)
        .setIn(["form", "filePreview"], data.get("file").preview);
    }

    case actions.CREATE_ARTICLE_IMAGE_ERROR: {
      const { errors, data } = action.payload;
      return state
        .setIn(["form", "error"], errors)
        .setIn(["form", "fileLoading"], false);
    }

    case actions.CREATE_ARTICLE_IMAGE_FINALLY: {
      return state.setIn(["form", "fileLoading"], false);
    }

    case actions.UPDATE_ARTICLE: {
      return state.setIn(["form", "loading"], true);
    }

    case actions.UPDATE_ARTICLE_SUCCESS: {
      const { data } = action.payload;
      return state.setIn(["form", "loading"], false);
    }

    case actions.UPDATE_ARTICLE_ERROR: {
      const { errors, data } = action.payload;
      return state
        .setIn(["form", "error"], errors)
        .setIn(["form", "loading"], false);
    }

    case actions.UPDATE_ARTICLE_FINALLY: {
      return state.setIn(["form", "loading"], false);
    }

    case actions.GET_ARTICLES_SUCCESS: {
      const { body, data } = action.payload;
      const nrs = normalize(body, { articles: arrayOf(article) });
      return state
        .update("map", map => map.merge(nrs.entities.articles))
        .update("results", rs => rs.set(hashFromObj(data), nrs.result));
    }

    case actions.GET_ARTICLE_SUCCESS: {
      const { body, data } = action.payload;
      const nrs = normalize(body, article);
      return state.update("map", map => map.merge(nrs.entities.articles));
    }

    case actions.DELETE_ARTICLE: {
      return state.setIn(["deleteStatus"], 1);
    }

    case actions.DELETE_ARTICLE_SUCCESS: {
      return state.setIn(["deleteStatus"], 2);
    }

    case actions.DELETE_ARTICLE_ERROR: {
      return state.setIn(["deleteStatus"], 3);
    }

    case actions.SET_DELETE_STATUS: {
      const { status } = action.payload;
      return state.setIn(["deleteStatus"], status);
    }

    case actions.SET_ARTICLE_PAGE: {
      const { page } = action.payload;
      const limit = state.getIn(["meta", "limit"]);
      return state
        .setIn(["meta", "currentPage"], page)
        .setIn(["meta", "offset"], (page - 1) * limit);
    }

    case actions.SET_ARTICLE_SORT: {
      const { field, dir } = action.payload;
      return state
        .setIn(["meta", "sortDir"], dir)
        .setIn(["meta", "sortField"], field);
    }

    case actions.ARTICLE_CLEAR_ERROR: {
      const { field } = action.payload;

      let errors =
        state.form.error && state.form.error && state.form.error.errors;
      if (errors && errors[field]) {
        errors[field] = undefined;
      }

      return state.setIn(["form", "error"], new ValidationError(errors));
    }

    case actions.ARTICLE_CLEAR_FORM: {
      return state.setIn(["form", "error"], null);
    }

    case actions.ARTICLE_CLEAR_FORM_PREVIEW: {
      return state.setIn(["form", "filePreview"], null);
    }

    default:
      return state;
  }
};

export default articlesReducer;



// WEBPACK FOOTER //
// ./src/common/article/reducer.js